import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1c235ab3"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "orangehrm-background-container" }
const _hoisted_2 = { class: "orangehrm-card-container ffj-roster" }
const _hoisted_3 = { class: "ffj-roster__header" }
const _hoisted_4 = { class: "orangehrm-main-title" }
const _hoisted_5 = {
  class: "ffj-roster__controls",
  "data-testid": "ffj-roster-controls"
}
const _hoisted_6 = {
  class: "ffj-roster__month-label",
  for: "ffj-roster-month"
}
const _hoisted_7 = ["disabled"]
const _hoisted_8 = {
  key: 0,
  class: "ffj-roster__loading",
  "data-testid": "ffj-roster-loading"
}
const _hoisted_9 = {
  key: 1,
  class: "ffj-roster__error",
  role: "alert",
  "data-testid": "ffj-roster-error"
}
const _hoisted_10 = {
  key: 2,
  class: "ffj-roster__empty",
  "data-testid": "ffj-roster-empty"
}
const _hoisted_11 = {
  key: 3,
  class: "ffj-roster__table",
  "data-testid": "ffj-roster-table"
}
const _hoisted_12 = ["data-testid", "onClick"]
const _hoisted_13 = ["data-testid"]
const _hoisted_14 = {
  key: 4,
  class: "ffj-roster__pagination",
  "data-testid": "ffj-roster-pagination"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_oxd_divider = _resolveComponent("oxd-divider")!
  const _component_oxd_pagination = _resolveComponent("oxd-pagination")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("header", _hoisted_3, [
        _createElementVNode("h6", _hoisted_4, _toDisplayString(_ctx.$t('forfait_jours.manager_roster_title')), 1)
      ]),
      _createVNode(_component_oxd_divider),
      _createElementVNode("section", _hoisted_5, [
        _createElementVNode("label", _hoisted_6, _toDisplayString(_ctx.$t('forfait_jours.month_selector_label')), 1),
        _withDirectives(_createElementVNode("input", {
          id: "ffj-roster-month",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.month) = $event)),
          type: "month",
          class: "ffj-roster__month-input",
          "data-testid": "ffj-roster-month-input",
          disabled: _ctx.isLoading,
          onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onMonthChange && _ctx.onMonthChange(...args)))
        }, null, 40, _hoisted_7), [
          [_vModelText, _ctx.month]
        ])
      ]),
      (_ctx.isLoading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(_ctx.$t('general.loading')), 1))
        : (_ctx.error)
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(_ctx.error), 1))
          : (_ctx.isEmpty)
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(_ctx.$t('forfait_jours.roster_empty')), 1))
            : (_openBlock(), _createElementBlock("table", _hoisted_11, [
                _createElementVNode("thead", null, [
                  _createElementVNode("tr", null, [
                    _createElementVNode("th", null, _toDisplayString(_ctx.$t('forfait_jours.roster_employee_label')), 1),
                    _createElementVNode("th", null, _toDisplayString(_ctx.$t('forfait_jours.roster_employee_id_label')), 1),
                    _createElementVNode("th", null, _toDisplayString(_ctx.$t('forfait_jours.roster_status_label')), 1),
                    _createElementVNode("th", null, _toDisplayString(_ctx.$t('forfait_jours.roster_action_label')), 1)
                  ])
                ]),
                _createElementVNode("tbody", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.entries, (entry) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: entry.empNumber,
                      "data-testid": `ffj-roster-row-${entry.empNumber}`,
                      class: _normalizeClass(`ffj-roster__row ffj-roster__row--${entry.status.toLowerCase()}`),
                      style: _normalizeStyle(_ctx.isRowClickable(entry) ? {cursor: 'pointer'} : {}),
                      onClick: ($event: any) => (_ctx.onRowClick(entry))
                    }, [
                      _createElementVNode("td", null, _toDisplayString(entry.fullName), 1),
                      _createElementVNode("td", null, _toDisplayString(entry.empNumber), 1),
                      _createElementVNode("td", null, [
                        _createElementVNode("span", {
                          class: _normalizeClass(`ffj-roster__status ffj-roster__status--${entry.status.toLowerCase()}`)
                        }, _toDisplayString(_ctx.$t(`forfait_jours.roster_status_${_ctx.statusToKey(entry.status)}`)), 3)
                      ]),
                      _createElementVNode("td", null, [
                        (_ctx.isRowClickable(entry))
                          ? (_openBlock(), _createElementBlock("span", {
                              key: 0,
                              class: "ffj-roster__action",
                              "data-testid": `ffj-roster-action-${entry.empNumber}`
                            }, _toDisplayString(entry.status === 'SIGNEE'
                    ? _ctx.$t('forfait_jours.download_signed_pdf')
                    : _ctx.$t('forfait_jours.roster_status_completed')), 9, _hoisted_13))
                          : _createCommentVNode("", true)
                      ])
                    ], 14, _hoisted_12))
                  }), 128))
                ])
              ])),
      (!_ctx.isLoading && !_ctx.error && !_ctx.isEmpty && _ctx.showPaginator)
        ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
            _createVNode(_component_oxd_pagination, {
              current: _ctx.currentPage,
              "onUpdate:current": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.currentPage) = $event)),
              length: _ctx.pages,
              "data-testid": "ffj-roster-pagination-control"
            }, null, 8, ["current", "length"])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}